import { Cell, Checkbox, ToastNotification } from '@zeiss/beyond-online-react';
import { Box, Grid } from '@zeiss/lib-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useWizardForm } from 'src/modules/Invitations/InvitationCreate/form';
import { getConfirmationFieldSchema } from 'src/modules/Invitations/InvitationCreate/schema';
import type { StepComponent } from 'src/modules/Invitations/InvitationCreate/types';

export const StepConfirmationFields: StepComponent = ({
  displayFieldError,
}) => {
  const form = useWizardForm();
  const { i18n, t } = useTranslation(['common', 'invitations']);

  const confirmationFieldSchema = useMemo(
    () => getConfirmationFieldSchema(t),
    [i18n.language, t],
  );

  return (
    <Grid>
      <Cell.Basic colSpan={[4, 6, 8]}>
        <form.Field
          name="step4.confirmation"
          validators={{
            onChange: confirmationFieldSchema,
            onSubmit: confirmationFieldSchema,
          }}
        >
          {(field) => {
            const error = displayFieldError(field);

            return (
              <>
                <Box>
                  <ToastNotification
                    description={t('invitations:text.confirmation')}
                    nonDismissible
                    title={t('invitations:title.confirmation')}
                    type="warning"
                  />
                </Box>

                <Box>
                  <Checkbox
                    checked={field.state.value}
                    error={error}
                    id={field.name}
                    label={t('invitations:text.terms')}
                    name={field.name}
                    onBlur={field.handleBlur}
                    onChange={(event) =>
                      field.handleChange(event.currentTarget.checked)
                    }
                  />
                </Box>
              </>
            );
          }}
        </form.Field>
      </Cell.Basic>
    </Grid>
  );
};
